import { Component, OnChanges, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { LoginService } from '../login/service/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as CryptoJS from 'crypto-js';
import { HttpErrorResponse } from '@angular/common/http';
import { SettingsService } from '../../views/layout/settings/service/settings.service';
import { NotifierService } from '../../services/Notifierservice';
import { MainService } from '../../views/layout/main/service/mainservice';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnChanges, OnDestroy {
  myOptions: any = {};
  myOptions2: any = {};
  myOptions3: any = {};
  sideExp: boolean = true;
  DropDownArrow = 'down';
  updatedUserName: string = '';
  profileData: any;
  profile!: boolean;
  userimage: any;
  userDetails: any;
  clientcodeId: any;
  userid: any;
  dateTime!: Date;
  selectedApps: string = '';
  private readonly notifier: NotifierService;
  subscription: Subscription;
  browserRefresh: boolean = false;
  showProfileImage = true;
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly router: Router,
    private readonly service: LoginService,
    private readonly notifierService: NotifierService,
    private readonly sanitizer: DomSanitizer,
    private readonly settingService: SettingsService,
    private readonly mainService: MainService,
  ) {
    this.notifier = notifierService;
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.browserRefresh = !router.navigated;
      }
    });
  }
  ngOnInit() {
    this.myOptions2 = {
      placement: 'right',
      display: this.sideExp,
      hideDelay: 0,
      showDelay: 400,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
      theme: 'light',
    };
    let user: any = localStorage.getItem('user');
    if (!user) {
      this.getUser();
    } else {
      try {
        const [saltHex, ivHex, cipherStr] = user.split('::');
        const salt = CryptoJS.enc.Hex.parse(saltHex);
        const iv = CryptoJS.enc.Hex.parse(ivHex);
        const key = CryptoJS.PBKDF2(this.service.enCryptKey, salt, {
          keySize: 32,
          iterations: 128,
          hasher: CryptoJS.algo.SHA256,
        });
        const decrypted = CryptoJS.AES.decrypt(cipherStr, key, { iv });
        this.userDetails = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
        this.service.userDetails = this.userDetails;
        this.profile = true;
      } catch (e) {
        localStorage.clear();
        this.router.navigateByUrl('login');
      }
    }

    this.loadUserProfile();

    this.settingService.companylogoBS
      .pipe(takeUntil(this.destroy$))
      .subscribe((update: any) => {
        if (update?.value === 'userimage') {
          this.loadUserProfile(); // refetch profile + image
          this.getUser();
        }
      });

    this.mainService.selectedAppsBS.subscribe((res) => {
      if (res.hasOwnProperty('name')) {
        this.mainService.selectedApp = res;

        if (res['name'] != 'ai-assist' && res['name'] != 'reports') {
          this.selectedApps = res['name'];
          this.router.navigateByUrl(res['url']);
        } else {
          window.open(res['url'], 'target = "_blank"');
        }
      }
    });

    if (localStorage.getItem('selectedApps')) {
      this.selectedApps =
        localStorage.getItem('selectedApps')?.toString() ?? '';
    }
  }

  loadUserProfile() {
    const loggedInUser = sessionStorage.getItem('loggedInUser');
    if (!loggedInUser) {
      this.showProfileImage = false;
      return;
    }

    let userId: number;
    try {
      // handles case where loggedInUser is stored as an object e.g. {"id": 64,...}
      const parsed = JSON.parse(loggedInUser);
      userId = typeof parsed === 'object' ? parsed?.id : parsed;
    } catch {
      // handles case where loggedInUser is stored as a plain id string
      userId = Number(loggedInUser);
    }

    if (!userId) {
      this.showProfileImage = false;
      return;
    }

    this.settingService.getProfile(userId).subscribe({
      next: (profile: any) => {
        this.profileData = profile;
        if (profile?.profile_image_name) {
          this.fetchProfileImage(profile.profile_image_name);
        } else {
          this.showProfileImage = false;
        }
      },
      error: () => {
        this.showProfileImage = false;
      },
    });
  }

  fetchProfileImage(profileImageName: string) {
    this.settingService.loadProfileImage(profileImageName).subscribe({
      next: (blob: Blob) => {
        const objectUrl = URL.createObjectURL(blob);
        this.userimage = objectUrl;
        this.showProfileImage = true;
      },
      error: (err) => {
        console.error('loadProfileImage error:', err);
        this.showProfileImage = false;
      },
    });
  }

  ngOnChanges() {
    this.myOptions = {
      placement: 'right',
      display: this.sideExp,
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
    };
    this.myOptions3 = {
      placement: 'right',
      display: this.sideExp,
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
    };
  }

  expandCollaspse() {
    this.sideExp = !this.sideExp;
    this.myOptions = {
      placement: 'right',
      display: this.sideExp,
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
    };
    this.myOptions3 = {
      placement: 'right',
      display: this.sideExp,
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
    };
  }

  showHideDropDown(value: string): void {
    if (value === 'up' || value === 'down') {
      this.DropDownArrow = value;
    }
  }

  getUser() {
    this.service.getUser().subscribe({
      next: (response: any) => {
        // ✅ Validate new structure
        if (!response?.id || !response.is_active) {
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigateByUrl('login');
          return;
        }

        this.userDetails = response;
        this.service.userDetails = response;

        // ✅ Use new id field (was 'userid')
        this.userid = response.id;

        // ✅ Encrypt with new salt::iv::cipher format
        const userSalt = CryptoJS.lib.WordArray.random(16);
        const userIv = CryptoJS.lib.WordArray.random(16);
        const userKey = CryptoJS.PBKDF2(this.service.enCryptKey, userSalt, {
          keySize: 32,
          iterations: 128,
          hasher: CryptoJS.algo.SHA256,
        });
        const encryptedUser = CryptoJS.AES.encrypt(
          JSON.stringify(response),
          userKey,
          { iv: userIv },
        );
        const storedUser =
          userSalt.toString() +
          '::' +
          userIv.toString() +
          '::' +
          encryptedUser.toString();
        localStorage.setItem('user', storedUser);

        // ✅ Removed plan_id / end_date checks — route based on apps
      },
      error: (error: HttpErrorResponse) => {
        this.notifier.notify(
          'error',
          error.error?.['message'] || 'Something went wrong.',
        );
      },
    });
  }


  clearStorage() {
    this.service.logout(this.userid).subscribe({
      next: (res: any) => {
        this.notifier.notify('default', 'You have successfully logged out.');
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
        this.router.navigate(['login']);
      },
      error: (error: HttpErrorResponse) => {},
    });
  }

  ngAfterViewInit() {
    if (!this.browserRefresh) {
      this.mainService.selectedAppsBS.next(this.selectedApps);
    }
    if (localStorage.getItem('selectedApps')) {
      this.selectedApps =
        localStorage.getItem('selectedApps')?.toString() ?? '';
    }
  }
  onImageError() {
    this.showProfileImage = false;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    if (this.userimage) {
      const raw =
        this.userimage.changingThisBreaksApplicationSecurity ?? this.userimage;
      URL.revokeObjectURL(raw);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
